module.exports = __webpack_public_path__ + "static/royal-fruit-acrylic-on-canvas-36x36in-c132db5ec79b345cf25d306ec586a5ad.jpg";